import dayjs from 'dayjs';

export const getDiffDate = (startDate, endDate = null) => {
  let targetDate = dayjs();
  if (endDate) {
    targetDate = dayjs(endDate);
  }
  return targetDate.diff(dayjs(startDate), 'day') + 1;
};

export const parseFullDateFromDb = (date) => {
  return date
    ? `${date.slice(4, 6)}/${date.slice(6, 8)}/${date.slice(0, 4)} ${date.slice(
        8,
        10
      )}:${date.slice(10)}`
    : '';
};

export const parseFullDateFromDb2 = (date) => {
  return date
    ? `${date.slice(6, 8)}/${date.slice(4, 6)}/${date.slice(0, 4)} ${date.slice(
        8,
        10
      )}:${date.slice(10)}`
    : '';
};

export const formatFullDateDisplay = (date) =>
  dayjs(date).format('DD/MM/YYYY hh:mm A');

export const formatDatePickerDate = (date) => {
  if (typeof date === 'string') {
    const tmp = date.split(' ');
    const newDate = tmp[0].split('/');
    return new Date(
      dayjs(`${newDate[1]}/${newDate[0]}/${newDate[2]} ${tmp[1]}`).format(
        'MM/DD/YYYY hh:mm A'
      )
    );
  }
  return new Date(dayjs(date).format('MM/DD/YYYY hh:mm A'));
};

export const parseDate = (date) =>
  date ? `${date.slice(6, 8)}/${date.slice(4, 6)}/${date.slice(0, 4)}` : '';

export const parseDate2 = (date) =>
  date ? `${date.slice(4, 6)}/${date.slice(6, 8)}/${date.slice(0, 4)}` : '';

export const formatDateTimeSave = (date, format = 'YYYYMMDDHHmm') => {
  if (!date) {
    return '';
  }
  if (typeof date !== 'string') {
    return dayjs(date).format(format);
  }
  const tmp = date.split(' ');
  const newDate = tmp[0].split('/');
  const newTime = tmp[1].split(':');
  return `${newDate[2]}${newDate[1]}${newDate[0]}${newTime[0]}${newTime[1]}`;
};

export const formatDateTimeToTimestamp = (date) => {
  if (!date) {
    return '';
  }
  if (dayjs(date).isValid()) {
    return dayjs(date).valueOf();
  }
  const tmp = date.split(' ');
  const newDate = tmp[0].split('/');
  const newTime = tmp[1].split(':');
  return dayjs(
    `${newDate[1]}/${newDate[0]}/${newDate[2]} ${newTime[0]}:${newTime[1]}`
  ).valueOf();
};

export const formatDateDisplay = (date, format = 'DD/MM/YYYY') => {
  return dayjs(date).format(format);
};

export const convertXAxisToDbDate = (data) => {
  const val = data.split('/');
  return `${val[2]}${val[1]}${val[0]}`;
};

export const parseHolidaysToDbDate = (data) => {
  const val = data.split('/');
  return `${val[2]}-${val[1]}-${val[0]}`;
};

export const parseFullDateFromDbWithSecond = (date) => {
  return date
    ? `${date.slice(4, 6)}/${date.slice(6, 8)}/${date.slice(0, 4)} ${date.slice(
        8,
        10
      )}:${date.slice(10, 12)}:${date.slice(12)}`
    : '';
};
